import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Home from "../pages/Home";
import Header from "../components/Header";
import Footer from "../components/footer";
import AboutUs from "../pages/AboutUs";
import ContactUs from "../pages/ContactUs";
import Service from "../pages/Service";
import Portfolio from "../pages/Portfolio";

// 🔹 Title Manager Component
function TitleManager() {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.toLowerCase();
        let pageTitle = "Enso Photography";

        switch (path) {
            case "/":
                pageTitle = "Enso Photography";
                break;
            case "/contact":
                pageTitle = "Contact Us - Enso";
                break;
            case "/aboutus":
                pageTitle = "About Us - Enso";
                break;
            case "/services":
                pageTitle = "Services - Enso";
                break;
            case "/portfolio":
                pageTitle = "Portfolio - Enso";
                break;
            default:
                pageTitle = "Enso Photography";
        }

        document.title = pageTitle;
    }, [location]);

    return null;
}

export default function AppRoutes() {
    return (
        <Router>
            <Header />
            <TitleManager /> {/* 🔹 Inject title manager */}
            <div className="pt-[120px]">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/Contact" element={<ContactUs />} />
                    <Route path="/AboutUs" element={<AboutUs />} />
                    <Route path="/Services" element={<Service />} />
                    <Route path="/Portfolio" element={<Portfolio />} />
                </Routes>
            </div>
            <Footer />
        </Router>
    );
}
